// extracted by mini-css-extract-plugin
module.exports = {"textInput":"CategoryEditBasicSection_textInput__2omF5","flag":"CategoryEditBasicSection_flag__1UJC9"};